import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { LoginAttempt } from '@core/authorization/models/login-attempt.interface';
import { Credentials } from '@pages/login/models/login-flow/credentials.interface';
import { LoginConfiguration } from '@pages/login/models/login-configuration/login-configuration.interface';
import { LoginConfigurationResponse } from '@pages/login/models/login-configuration/login-configuration-response.type';
import { AuthorizationData } from '@kaseya-shared';
import { useMfaToken } from '@core/authorization/models/mfa-token-context';
import { hideServerNotRespondWarningWhenDegraded } from '@core/errors/models/context';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  private readonly httpClient = inject(HttpClient);

  logIn(credentials: Credentials): Observable<LoginAttempt> {
    const url = 'api/v3/login/credentials';

    return this.httpClient.post<LoginAttempt>(environment.portalApiUrl + url, credentials, {
      context: hideServerNotRespondWarningWhenDegraded(),
    });
  }

  getLoginInfo(loginConfiguration: LoginConfiguration): Observable<LoginConfigurationResponse> {
    const url = 'api/v1/login/info';

    return this.httpClient.post<LoginConfigurationResponse>(environment.portalApiUrl + url, loginConfiguration, {
      context: hideServerNotRespondWarningWhenDegraded(),
    });
  }

  checkMfa(mfaToken: string): Observable<AuthorizationData> {
    const url = 'api/v3/totp';

    return this.httpClient.post<AuthorizationData>(
      environment.portalApiUrl + url,
      {},
      {
        context: useMfaToken(mfaToken),
      }
    );
  }
}
